<template>
  <!-- prettier-ignore -->
  <FormItem :error="error" :prop="fieldName">
    <span v-if="label !== undefined" slot="label" class="n-field-label">{{ $t(`label.${label}`) }}</span>
    <span v-else-if="customLabel !== undefined" slot="label" class="n-field-label">{{ customLabel }}</span>
    <div :class="modifiedIcon ? 'n-input-item-icon' : 'n-input-item'">
      <i-select v-model="n_value" transfer multiple :filterable="!disabled" :placeholder="placeholder === undefined ? '' : this.$t(`label.${placeholder}`)" :max-tag-count="1" :max-tag-placeholder="maxTagPlaceholder" :class="[viewTagPlaceholder ? 'n-tag-placeholder' : '', disabled ? 'n-select-disabled' : '']" @on-change="onChange" @on-select="onSelect">
        <template v-if="options.length > 0">
          <Option :value="0" :style="{ color: allChecked ? 'rgba(45, 140, 240, 0.9)' : '', borderBottom: '1px solid #e8eaec' }" :disabled="disabled" @click.native="clickSelectAll">
            <Checkbox :value="allChecked" :indeterminate="checked.filter(f => f).length > 0 && !allChecked" :disabled="disabled || options.length === 0" />
            Select ALL
          </Option>
        </template>
        <Option v-for="(option, index) in options" :key="option.value" :value="option.value" :disabled="disabled">
          <Checkbox :value="checked[index]" :disabled="disabled" />
          {{ $t(option.name) }}
        </Option>
      </i-select>
    </div>
    <Tooltip v-if="isModified" placement="right-start" :max-width="500" :content="showName(initValue)" transfer class="ml-2">
      <Icon custom="fas fa-pen" size="14" style="cursor: pointer;" />
    </Tooltip>
  </FormItem>
</template>

<script>
import Base from '../base';
import { beanCopy, compare, isEmpty } from '@/helpers/utils';
import { TYPES } from '@/constant/bitwise';
import _ from 'lodash-es';

export default Base.extend({
  name: 'NFieldMaskEnum',
  props: {
    typeName: String,
    value: Number,
    selectAll: Boolean,
  },
  data() {
    return {
      n_value: null,
      checked: [],
      allChecked: false,
    };
  },
  computed: {
    options() {
      return Object.keys(TYPES[this.typeName]).map(k => ({ name: k, value: TYPES[this.typeName][k] }));
    },
    activeValue() {
      let activeValue = [];
      if (!isEmpty(this.n_value))
        this.n_value.forEach(o => {
          if (o !== 0) activeValue.push(o);
        });
      return activeValue;
    },
    allValue() {
      let allValue = [];
      this.options.forEach(o => {
        allValue.push(o.value);
      });
      return allValue;
    },
    viewTagPlaceholder() {
      return isEmpty(this.n_value) ? false : this.n_value.length > 1;
    },
    isModified() {
      return this.showModifyIcon && this.initValue !== this.value;
    },
  },
  watch: {
    value(to) {
      let v = this.valueToArray(to);
      if (!compare(v, this.n_value)) this.n_value = v;
    },
  },
  created() {
    this.initValue = this.value;
    this.n_value = this.selectAll ? this.allValue : this.valueToArray(this.value);
    this.initChecked();
    this.initAllChecked();
  },
  methods: {
    initChecked() {
      this.options.forEach((option, index) => {
        this.checked[index] = !isEmpty(this.n_value) && this.n_value.find(v => v === option.value) !== undefined;
      });
    },
    initAllChecked() {
      this.allChecked = this.activeValue.length > 0 && this.activeValue.length === this.allValue.length;
    },
    maxTagPlaceholder(num) {
      let selected = num + 1;
      return selected === this.options.length ? `ALL selected (${selected})` : `Selected (${selected})`;
    },
    valueToArray(v) {
      if (isEmpty(v) || v === 0) return [];
      let array = Object.values(TYPES[this.typeName]);

      // prettier-ignore
      for (let i = 1; i < (1 << array.length); i++) {
        let sum = 0;
        let arr = [];
        for (let j = 0; j < array.length; j++) {
          if ((i & (1 << j)) !== 0) {
            sum += array[j];
            arr.push(array[j]);
          }
        }
        if (sum === v) return arr;
      }
      return [];
    },
    showName(value) {
      let v = this.valueToArray(value);
      if (isEmpty(v)) return null;
      let r = [];
      v.forEach(_v => {
        let n = this.options.find(f => f.value === _v).name;
        r.push(this.$t(n));
      });
      return r.join(', ');
    },
    clickSelectAll() {
      if (this.disabled) return;
      this.allChecked = !this.allChecked;
      this.n_value = this.allChecked ? this.allValue : [];
      this.$emit('on-select', this.allChecked ? this.allValue : []);
    },
    onChange(value) {
      if (value.length > 0 && value.indexOf(0) !== -1) return;
      let v = isEmpty(value) ? 0 : _.sum(value);
      if (v === this.value) return;
      this.initChecked();
      this.initAllChecked();
      this.$emit('input', v);
      this.$emit('on-change', v);
    },
    onSelect(select) {
      if (select.label === ' Select ALL ') return;
      let selectValue = !isEmpty(this.n_value) ? beanCopy(this.n_value) : [];
      if (selectValue.find(f => f === select.value) === undefined) selectValue.push(select.value);
      else selectValue = selectValue.filter(f => f !== select.value);
      this.$emit('on-select', selectValue);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '../base';
@import 'style';
</style>
